// list out the IdentifyAsAnyOneData data
const IdentifyAsAnyOneData = ['Impact Startup', 'Female Founder', 'Founder of Color', 'LGBTQ Founder']

export default IdentifyAsAnyOneData
